<template>
  <section class="repetitor-seo v2-container-small">
    <h2>
      <b>8 НЕОЧЕВИДНЫХ</b> причин <br>
      заниматься с&nbsp;репетиторами «Синергии»
    </h2>

    <div class="repetitor-seo__text">
      <h6>Для родителей</h6>
      <ul>
        <li>
          <b>Экономия времени и&nbsp;усилий.</b> Не&nbsp;нужно тратить время на&nbsp;поиск
          материалов, планирование уроков и&nbsp;проведение занятий. Репетитор уже
          обладает необходимыми знаниями и&nbsp;опытом для обучения детей
        </li>
        <li>
          <b>Развитие доверительных отношений.</b> Репетитор&nbsp;&mdash; надежный партнер
          и&nbsp;советчик для родителей, всегда поможет лучше понять потребности
          и&nbsp;проблемы ребенка в&nbsp;учебе
        </li>
        <li>
          <b>Облегчение образовательного процесса.</b> Репетитор может предложить родителям
          индивидуальный план обучения и&nbsp;пошаговые стратегии, чтобы помочь ребенку
          справиться с&nbsp;учебными трудностями
        </li>
        <li>
          <b>Повышение уверенности.</b> Прогресс и&nbsp;успех ребенка под руководством
          профессионального репетитора даст почувствовать большую уверенность
          в&nbsp;своих возможностях воспитания и&nbsp;обучения ребенка
        </li>
      </ul>
    </div>

    <div class="repetitor-seo__text">
      <h6>Для учеников</h6>
      <ul>
        <li>
          <b>Индивидуальный подход.</b> Такой подход учитывает способности и&nbsp;уровень знаний.
          Это позволяет получать учебные материалы и&nbsp;задания,
          нацеленные на&nbsp;конкретные потребности
        </li>
        <li>
          <b>Дополнительные объяснения и помощь.</b> Репетитор заполняет пробелы дополнительными
          объяснениями и&nbsp;упражнениями по&nbsp;сложным темам, что помогает лучше усвоить
          материал и&nbsp;преодолеть учебные трудности
        </li>
        <li>
          <b>Улучшение социальных навыков.</b> В&nbsp;процессе обучения также развиваются навыки
          самоорганизации, концентрации и&nbsp;планирования учебных задач, что способствует успехам
          не&nbsp;только в&nbsp;учебе, но&nbsp;и&nbsp;во&nbsp;многих других сферах жизни
        </li>
        <li>
          <b>Повышение самооценки и уверенности.</b> Успехи и&nbsp;прогресс, достигнутые при
          обучении с&nbsp;репетитором, помогают повысить самооценку и&nbsp;уверенность
          в&nbsp;своих академических способностях
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RepetitorSeo',
};
</script>

<style scoped lang="scss">

.repetitor-seo {
  padding: 60px;
  background-color: $white-color;
  border-radius: 20px;

  @include media-down(laptop) {
    padding: 40px 32px;
  }

  @include media-down(tablet) {
    padding-inline: 16px;
  }

  h2 {
    margin-bottom: 20px;
    position: relative;

    font-weight: 700;
    font-size: 45px;
    line-height: 1;
    letter-spacing: -1.35px;
    text-transform: uppercase;
    color: $black;

    @include media-down(tablet) {
      margin-bottom: 32px;

      font-size: 30px;
      line-height: 110%;
    }

    &::before {
      content: '';
      height: 43px;
      width: 372px;
      position: absolute;
      left: -10px;
      top: -0.75px;
      background-color: $blue-dark;

      @include media-down(tablet) {
        width: 246px;
        height: 34px;
        left: -8px;
        top: 0.25px;
      }
    }

    b {
      color: $white-color;
      position: relative;
    }
  }

  .repetitor-seo__text {
    &:not(:last-of-type) {
      margin-bottom: 32px;
    }

    h6 {
      margin-bottom: 8px;

      font-weight: 500;
      font-size: 24px;
      line-height: 130%;
      color: $black;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-left: 24px;

      @include media-down(tablet) {
        padding-left: 14px;
      }

      li {
        font-size: 18px;
        line-height: 122%;
        color: $black;
        list-style-image: url("/v2/catalog/repetitor/circle.svg");

        b {
          font-weight: 700;
        }
      }
    }
  }
}

</style>
